import { render, staticRenderFns } from "./BarraNavegacion.vue?vue&type=template&id=3ede8f3e&scoped=true&"
import script from "./BarraNavegacion.vue?vue&type=script&lang=js&"
export * from "./BarraNavegacion.vue?vue&type=script&lang=js&"
import style0 from "./BarraNavegacion.vue?vue&type=style&index=0&id=3ede8f3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ede8f3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VAppBarNavIcon } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAppBar,VAppBarNavIcon,VBtn,VIcon,VSpacer})
